import { Box, IconButton, Popover, Typography } from '@mui/material';
import React from 'react';
import InfoIcon from '@mui/icons-material/Info';
import { selectInfo } from '../stateManagement/infoSlice';
import { useSelector } from 'react-redux';

const InfoComponent: React.FC<{ children: React.ReactNode; infoContent: React.ReactNode; isLeftHorizontal?: boolean }> = ({ children, infoContent, isLeftHorizontal }) => {

  const infoState = useSelector(selectInfo);

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <Box sx={{ position: 'relative' }}>
      <Box sx={{ pointerEvents: (infoState && infoContent && children) ? 'none' : 'auto', opacity: (infoState && infoContent) ? 0.7 : 1 }}>
        {children}
      </Box>
      {(infoState && infoContent && children) &&
        <>
          <IconButton
            size="small"
            color="success"
            onClick={handleOpen}
            sx={{
              position: 'absolute',
              top: '8px',
              ...(isLeftHorizontal ? { left: '8px' } : { right: '8px' }),
              zIndex: 1,
            }}
          >
            <InfoIcon />
          </IconButton>
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            // anchorOrigin={{
            //   vertical: 'bottom',
            //   horizontal: 'left',
            // }}
            // transformOrigin={{
            //   vertical: 'top',
            //   horizontal: 'left',
            // }}
            PaperProps={{
              sx: {
                maxWidth: '90vw'
              },
            }}

          >
            <Typography sx={{ whiteSpace: 'pre-line', backgroundColor: 'lightgreen', p: 1, fontSize: '0.9rem' }}>{infoContent}</Typography>
          </Popover>
        </>
      }

    </Box>
  );
};

export default InfoComponent;
